import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-guards',
  templateUrl: './psa-guards.component.html',
  styleUrls: ['./psa-guards.component.css']
})
export class PsaGuardsComponent implements OnInit {
  title="Guards Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-guards/psa-guards.component.ts